import { DownloadWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Download')
export class DownloadConnectorProvider extends ConnectorProvider<DownloadWorkflowNode> {}
